/* Stooner - Producto Pro: galeria, variantes, carrito, entrega estimada, guia de tallas y barra fija */
let Ev = null;
try {
  Ev = await import('@shopify/events');
} catch (e) {
  Ev = null;
}

const lang = document.documentElement.lang || 'es';
const q = (r, s) => r.querySelector(s);
const qa = (r, s) => Array.prototype.slice.call(r.querySelectorAll(s));

/* ---------- Fechas ---------- */
const isWE = (d) => d.getDay() === 0 || d.getDay() === 6;
function nextBiz(d, skip) {
  const r = new Date(d);
  if (skip) while (isWE(r)) r.setDate(r.getDate() + 1);
  return r;
}
function addDays(d, n, skip) {
  const r = new Date(d);
  let i = 0;
  while (i < n) {
    r.setDate(r.getDate() + 1);
    if (!skip || !isWE(r)) i++;
  }
  return r;
}
function fmt(d) {
  return d.toLocaleDateString(lang, { day: 'numeric', month: 'short' }).replace('.', '');
}
function fmtW(d) {
  return d.toLocaleDateString(lang, { weekday: 'long', day: 'numeric', month: 'short' }).replace('.', '');
}
function span(a, b, f) {
  const fn = f || fmt;
  const x = fn(a);
  const y = fn(b);
  return x === y ? x : x + ' \u2013 ' + y;
}
function orderInfo(cut, skip) {
  const now = new Date();
  let target = new Date(now);
  target.setHours(cut, 0, 0, 0);
  if (now >= target || (skip && isWE(now))) {
    target = new Date(now);
    target.setDate(target.getDate() + 1);
    target = nextBiz(target, skip);
    target.setHours(cut, 0, 0, 0);
  }
  const od = new Date(target);
  od.setHours(12, 0, 0, 0);
  return { now, target, od };
}

function setupEta(el) {
  if (el.dataset.ready) return;
  el.dataset.ready = '1';
  const cut = Number(el.dataset.cutoff);
  const skip = el.dataset.weekends === 'true';
  const cutoff = Number.isNaN(cut) ? 16 : cut;
  const dateFmt = el.dataset.weekday === 'true' ? fmtW : fmt;
  let timerNode = null;
  let datesNode = null;

  if (el.hasAttribute('data-eta')) {
    const tpl = el.dataset.template || '';
    el.textContent = '';
    tpl.split(/(\{timer\}|\{dates\})/).forEach((part) => {
      if (part === '{timer}') {
        timerNode = document.createElement('span');
        timerNode.className = 'stp-eta__timer';
        el.appendChild(timerNode);
      } else if (part === '{dates}') {
        datesNode = document.createElement('strong');
        el.appendChild(datesNode);
      } else if (part) {
        el.appendChild(document.createTextNode(part));
      }
    });
  }

  function tick() {
    const { now, target, od } = orderInfo(cutoff, skip);
    if (el.hasAttribute('data-eta')) {
      const ms = Math.max(0, target - now);
      const h = Math.floor(ms / 3600000);
      const m = Math.floor((ms % 3600000) / 60000);
      const s = Math.floor((ms % 60000) / 1000);
      if (timerNode) timerNode.textContent = [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
      if (datesNode) datesNode.textContent = span(addDays(od, Number(el.dataset.min) || 0, skip), addDays(od, Number(el.dataset.max) || 0, skip), dateFmt);
    } else {
      const o = q(el, '[data-date=order]');
      const p = q(el, '[data-date=prep]');
      const d = q(el, '[data-date=deliv]');
      if (o) o.textContent = fmt(od);
      if (p) p.textContent = span(addDays(od, Number(el.dataset.pmin) || 0, skip), addDays(od, Number(el.dataset.pmax) || 0, skip));
      if (d) d.textContent = span(addDays(od, Number(el.dataset.dmin) || 0, skip), addDays(od, Number(el.dataset.dmax) || 0, skip));
    }
  }
  tick();
  if (el.hasAttribute('data-eta') && timerNode) setInterval(tick, 1000);
}

/* ---------- Galeria ---------- */
function setupGallery(root) {
  const g = q(root, '.stp-g');
  if (!g || g.dataset.ready) return null;
  g.dataset.ready = '1';
  const track = q(g, '.stp-g__track');
  const stage = q(g, '.stp-g__stage');
  const slides = qa(track, '.stp-slide');
  const thumbsRow = q(g, '.stp-g__thumbs');
  const thumbs = qa(g, '.stp-thumb');
  const cur = q(g, '[data-cur]');
  const dots = [];
  let raf = 0;

  function idx() {
    const w = track.clientWidth;
    return w ? Math.round(track.scrollLeft / w) : 0;
  }
  function setActive(i) {
    thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
    dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    if (cur) cur.textContent = String(i + 1);
    const t = thumbs[i];
    if (t && thumbsRow && thumbsRow.offsetParent !== null) {
      if (getComputedStyle(thumbsRow).flexDirection === 'column') {
        thumbsRow.scrollTo({ top: t.offsetTop - thumbsRow.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
      } else {
        thumbsRow.scrollTo({ left: t.offsetLeft - thumbsRow.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }
    }
  }
  function go(i) {
    const n = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
  }

  if (stage && slides.length > 1) {
    const wrap = document.createElement('div');
    wrap.className = 'stp-dots';
    slides.forEach((s, k) => {
      const d = document.createElement('button');
      d.type = 'button';
      d.className = 'stp-dot' + (k === 0 ? ' is-active' : '');
      d.setAttribute('aria-label', 'Imagen ' + (k + 1));
      d.addEventListener('click', () => go(k));
      wrap.appendChild(d);
      dots.push(d);
    });
    stage.appendChild(wrap);
  }

  track.addEventListener(
    'scroll',
    () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        setActive(idx());
      });
    },
    { passive: true }
  );
  const prev = q(g, '.stp-arrow--prev');
  const next = q(g, '.stp-arrow--next');
  if (prev) prev.addEventListener('click', () => go(idx() === 0 ? slides.length - 1 : idx() - 1));
  if (next) next.addEventListener('click', () => go(idx() >= slides.length - 1 ? 0 : idx() + 1));
  thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));

  slides.forEach((s) => {
    s.addEventListener('mousemove', (e) => {
      const r = s.getBoundingClientRect();
      s.style.setProperty('--zx', ((e.clientX - r.left) / r.width) * 100 + '%');
      s.style.setProperty('--zy', ((e.clientY - r.top) / r.height) * 100 + '%');
    });
  });

  return {
    toMedia(id) {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (i >= 0) go(i);
    },
  };
}

/* ---------- Producto ---------- */
function setupProduct(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';
  const dataEl = q(root, '[data-stp-data]');
  if (!dataEl) return;
  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  const gallery = setupGallery(root);
  const fieldsets = qa(root, '.stp-opt');
  const form = q(root, '[data-stp-form]');
  const sticky = q(root, '[data-sticky]');

  const state = () =>
    fieldsets.map((fs) => {
      const c = q(fs, 'input:checked');
      return c ? c.value : null;
    });
  const find = (sel) => {
    if (!fieldsets.length) return data.variants[0];
    return data.variants.find((v) => v.o.every((x, i) => x === sel[i]));
  };

  function refreshAvail(sel) {
    fieldsets.forEach((fs, i) => {
      qa(fs, '.stp-val').forEach((lab) => {
        const val = q(lab, 'input').value;
        const ok = data.variants.some((v) => v.a && v.o[i] === val && v.o.every((x, j) => j === i || x === sel[j]));
        lab.classList.toggle('is-out', !ok);
      });
      const vt = q(fs, '[data-value]');
      if (vt) vt.textContent = sel[i] || '';
    });
  }

  function applyVariant(v) {
    qa(root, '[data-variant-id]').forEach((i) => {
      i.value = v ? v.id : '';
      i.disabled = !v;
      i.dispatchEvent(new Event('change', { bubbles: true }));
    });

    qa(root, '[data-price-wrap]').forEach((w) => {
      if (!v) return;
      const p = q(w, '[data-price]');
      const c = q(w, '[data-compare]');
      const b = q(w, '[data-badge]');
      if (p) p.textContent = v.p;
      const sale = Boolean(v.c);
      w.dataset.sale = sale ? 'true' : 'false';
      if (c) {
        c.hidden = !sale;
        c.textContent = v.c || '';
      }
      if (b) {
        if (sale && v.cr > v.pr) {
          b.hidden = false;
          b.textContent = w.dataset.badgeMode === 'percent' ? '-' + Math.round((1 - v.pr / v.cr) * 100) + '%' : w.dataset.badgeText;
        } else {
          b.hidden = true;
        }
      }
    });

    qa(root, '[data-stock]').forEach((s) => {
      let st = 'out';
      let text = s.dataset.tOut;
      if (v && v.a) {
        const low = Number(s.dataset.low) || 0;
        if (v.im && low > 0 && v.q > 0 && v.q <= low) {
          st = 'low';
          text = s.dataset.tLow.replace('{n}', v.q);
        } else {
          st = 'in';
          text = s.dataset.tIn;
        }
      }
      s.dataset.state = st;
      const t = q(s, '[data-stock-text]');
      if (t) t.textContent = text;
    });

    qa(root, '[data-atc]').forEach((b) => {
      if (b.classList.contains('is-added')) return;
      const tx = q(b, '[data-atc-text]') || b;
      const pr = q(b, '[data-atc-price]');
      if (!v) {
        b.disabled = true;
        tx.textContent = b.dataset.unavailable;
        if (pr) pr.hidden = true;
      } else if (!v.a) {
        b.disabled = true;
        tx.textContent = b.dataset.soldout;
        if (pr) pr.hidden = true;
      } else {
        b.disabled = false;
        tx.textContent = b.dataset.label;
        if (pr) {
          pr.hidden = false;
          pr.textContent = '\u2014 ' + v.p;
        }
      }
    });

    if (sticky) {
      const sb = q(sticky, '[data-sticky-btn]');
      const sp = q(sticky, '[data-sticky-price]');
      if (sp && v) sp.textContent = v.p;
      if (sb) {
        sb.disabled = !v || !v.a;
        sb.textContent = !v ? sb.dataset.unavailable : v.a ? sb.dataset.label : sb.dataset.soldout;
      }
    }
  }

  function onChange(user) {
    const sel = state();
    const v = find(sel);
    applyVariant(v);
    refreshAvail(sel);
    if (user) {
      if (v && gallery && v.m) gallery.toMedia(v.m);
      if (v) {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }
  }

  root.addEventListener('change', (e) => {
    if (e.target instanceof Element && e.target.closest('.stp-opt')) onChange(true);
  });
  onChange(false);

  /* Cantidad */
  const qty = q(root, '[data-qty]');
  const minus = q(root, '[data-qty-minus]');
  const plus = q(root, '[data-qty-plus]');
  if (qty) {
    if (minus) minus.addEventListener('click', () => (qty.value = Math.max(1, Number(qty.value) - 1)));
    if (plus) plus.addEventListener('click', () => (qty.value = Number(qty.value) + 1));
  }

  /* Anadir al carrito */
  let busy = false;
  async function add() {
    if (busy || !form) return;
    const idInput = q(form, '[data-variant-id]');
    if (!idInput || !idInput.value) return;
    busy = true;
    const msg = q(root, '[data-msg]');
    const btn = q(root, '[data-atc]');
    const quantity = qty ? Math.max(1, Number(qty.value) || 1) : 1;
    const routes = (window.Theme && window.Theme.routes) || {};
    const addUrl = routes.cart_add_url || '/cart/add.js';
    const cartUrl = routes.cart_url || '/cart';
    let deferred = null;

    if (Ev && Ev.CartLinesUpdateEvent) {
      try {
        deferred = Ev.CartLinesUpdateEvent.createPromise();
        form.dispatchEvent(
          new Ev.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(idInput.value), quantity }],
            promise: deferred.promise,
          })
        );
      } catch (e) {
        deferred = null;
      }
    }
    const sectionIds = qa(document, 'cart-items-component').map((el) => el.dataset.sectionId).filter(Boolean);
    const payload = { items: [{ id: Number(idInput.value), quantity }] };
    if (sectionIds.length) payload.sections = sectionIds.join(',');
    if (btn) btn.classList.add('is-busy');
    if (msg) msg.textContent = '';

    try {
      const res = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const json = await res.json();
      const cart = await fetch(cartUrl + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
      if (deferred) {
        deferred.resolve({
          cart: Ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'stooner-product',
            sourceId: root.id || '',
            itemCount: quantity,
            productId: String(data.id),
            sections: json.sections,
            didError: Boolean(json.status),
          },
        });
      }
      if (json.status) {
        if (msg) msg.textContent = json.description || json.message || '';
      } else if (btn) {
        btn.classList.add('is-added');
        const tx = q(btn, '[data-atc-text]') || btn;
        tx.textContent = btn.dataset.added || btn.dataset.label;
        setTimeout(() => {
          btn.classList.remove('is-added');
          onChange(false);
        }, 1600);
      }
    } catch (err) {
      if (deferred) deferred.reject(err);
      if (msg) msg.textContent = 'Error de conexion';
    } finally {
      busy = false;
      if (btn) btn.classList.remove('is-busy');
    }
  }
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      add();
    });
  }

  /* Barra fija */
  if (sticky) {
    const sb = q(sticky, '[data-sticky-btn]');
    if (sb) sb.addEventListener('click', () => (form && form.requestSubmit ? form.requestSubmit() : add()));
    const target = q(root, '[data-atc]');
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0));
        },
        { threshold: 0 }
      ).observe(target);
    }
  }

  /* Guia de tallas */
  root.addEventListener('click', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest('[data-guide-open]')) {
      const d = q(root, 'dialog[data-guide]');
      if (d && d.showModal) d.showModal();
    } else if (t.closest('[data-guide-close]') || (t.matches && t.matches('dialog[data-guide]'))) {
      const d = q(root, 'dialog[data-guide]');
      if (d) d.close();
    }
  });

  qa(root, '[data-eta], [data-eta-tl]').forEach(setupEta);
}

function initAll() {
  qa(document, '[data-stp]').forEach(setupProduct);
}
document.addEventListener('shopify:section:load', initAll);
document.addEventListener('shopify:block:select', initAll);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
else initAll();